import { BufferGeometry, Material, Object3D, Quaternion , Vector3 } from 'three';
import { IV3D } from '@/Interfaces/v3d';
export type xyz = [number, number, number];

export type xy = [number, number];
declare let v3d: IV3D;
export interface v3dMaterial extends Material {
    nodeRGBMap: { [key: string]: number };
    nodeRGB: Array<Vector3>;
}
export interface v3dMesh extends Object3D {
    material: v3dMaterial,
    geometry: BufferGeometry,
}

export const scaleLeft = new Vector3(-1, 1, 1);
export const scaleRight = new Vector3(-1, 1, 1);

export const redMat = new v3d.MeshBasicMaterial({
    color: 0xff0000,
    transparent: true,
    opacity: 0.3,
});

const geometry = new v3d.BoxGeometry(1, 1, 1);
const wireframe = new v3d.WireframeGeometry(geometry);
const material = new v3d.LineBasicMaterial({ color: '#06bb2b', transparent: true, opacity: 0.5 });
export const selectBox = new v3d.LineSegments(wireframe, material);

export const worldPos = new Vector3();
export const worldQuaternion = new Quaternion();
